<template>
  <div>
    <main class="bg-nucleus-lightestBlue dark:bg-nucleus-darkestBlue flex-grow">
      <slot />
    </main>
  </div>
</template>
